import { atomFamily, atomWithRefresh } from 'jotai/utils';
import { guardedClient } from '../../../auth/api/clients';
import { recordingResponseSchema } from '@minutes-system/backend/src/api/recordings/schema';
import fetchAndValidate from '../../../../lib/fetchAndValidate';

export const recordingQueryAtom = atomFamily((recordingId: number) =>
  atomWithRefresh(() =>
    fetchAndValidate(
      guardedClient.recordings[':id'].$get({ param: { id: String(recordingId) } }) as Promise<Response>,
      recordingResponseSchema
    )
  )
);
